import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { HubStatuses } from "@miplatform/types";
import { capitalize } from "@miplatform/utils";
import { mdiCircle } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const SignalRConnectionIndicator: FC<
  SignalRConnectionIndicatorProps
> = ({ connectionStatus }) => {
  const { classes, theme } = useStyles();

  let connectionColor = theme.palette.red.dark;

  if (connectionStatus === HubStatuses.Reconnecting) {
    connectionColor = theme.palette.amber.main;
  } else if (
    connectionStatus === HubStatuses.Connected ||
    connectionStatus === HubStatuses.Reconnected
  ) {
    connectionColor = theme.palette.green.main;
  }

  return (
    <Box className={classes.connectedContainer}>
      <MiIcon color={connectionColor} size={0.4} path={mdiCircle} />
      <Typography fontSize={theme.fontSize.small} color={connectionColor}>
        {capitalize(connectionStatus)}
      </Typography>
    </Box>
  );
};

interface SignalRConnectionIndicatorProps {
  connectionStatus: HubStatuses;
}

const useStyles = makeStyles()((theme) => ({
  connectedContainer: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    marginLeft: theme.spacing(2),
    width: 100,
  },
}));
